import Home from '@/views/Home.vue'
import Login from '@/components/Login'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Dashboard from '@/views/layouts/Dashboard'
import Front from '@/views/layouts/Front'

export default [
  {
    path: '/',
    component: Dashboard,
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
        path: 'about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      }
    ]
  },
  {
    path: '',
    component: Front,
    children: [
      {
        path: '/login',
        name: 'login_path',
        component: Login,
        meta: {
          guest: true
        }
      },
      {
        path: '/senha/resetar',
        name: 'password_reset_path',
        component: ForgotPassword,
        meta: {
          guest: true
        }
      },
      {
        path: '/senha/resetar/:token',
        name: 'password_reset_token_path',
        component: ResetPassword,
        meta: {
          guest: true
        }
      }
    ]
  }
]
